export const isFormValid = (validationModel: any, formData: any): boolean => {
    let isValid = true;
    for (var prop in validationModel?.fields) {
        if (Object.prototype.hasOwnProperty.call(validationModel?.fields, prop)) {
            const validationField = validationModel?.fields[prop];
            if (validationField?.isRequired) {
                const field = formData[prop];
                if (!field) {
                    isValid = false;
                }
            }
        }
    }
    return isValid;
}

export const validateForm = (validationModel: any, formData: any, isEditMode: boolean) => {
    let isValid = true;
    for (var prop in validationModel?.fields) {
        if (Object.prototype.hasOwnProperty.call(validationModel?.fields, prop)) {
            const validationField = validationModel?.fields[prop];
            validationField.errors = [];
            validationField.isValid = true;
            let errors: any[] = [];
            if (validationField?.isRequired) {
                const field = formData[prop];
                if (!field && field !== '0' && field !== 0 && ((isEditMode && !validationField.isDisabledInEditMode) || !isEditMode)) {
                    errors.push('Povinne pole');
                    validationField.isValid = false;
                    isValid = false;
                }
            }
            validationField.errors = [...errors]
        }
    }
    validationModel.isValid = isValid;
}

export const validateField = (value: any, validationField: any) => {
    if (validationField) {
        validationField.errors = [];
        validationField.isValid = true;
        let errors: any[] = [];
        if (validationField?.isRequired) {
            if (!value && value !== 0) {
                errors.push('Povinne pole');
                validationField.isValid = false;
            }
        }
        validationField.errors = [...errors]
    }
}